import { Route } from '@angular/router';

export const DisbursementSummaryRoutes: Route[] = [
    // uncomment for testing
    // {
    //    path: 'view/:id', component: DisbursementSummaryComponent, canActivate: [UserBusinessUnitAuthGuard]
    // }
];
